/* eslint-disable @typescript-eslint/no-misused-promises */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable camelcase */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-var-requires */
import * as React from 'react'
import { TFunction, useTranslation } from 'react-i18next'
import { view } from 'react-easy-state'
import { useNavigate } from 'react-router-dom'
import { Box, Text, useDisclosure } from '@chakra-ui/react'
import { yupResolver } from '@hookform/resolvers/yup'
import * as yup from 'yup'
import { SubmitHandler, useForm } from 'react-hook-form'
import AlertError from '../../components/generics/AlertError'
import { HiLocationMarker } from 'react-icons/hi'
import dayjs from 'dayjs'

// validate
import newNotifyStore from '../../core/stores/Viriyah/newNotifyStore'
import FormItem from '../../components/generics/FormItem'
import ButtonChakra from '../../components/generics/ButtonChakra'
import { IValueString } from '../../core/Types/BaseModel'
import ModalGoogleMap from '../../components/generics/map/ModalGoogleMap'
const customParseFormat = require('dayjs/plugin/customParseFormat')
dayjs.extend(customParseFormat)

interface MakeClaimFormState {
  incidentLocation: string
  dateIncident: string
  incidentLandmark: string
  haveLitigant: string
  errorMessage: string
  incidentLocationLng: string
  incidentLocationLat: string
}

const validationSchema = (t: TFunction<'translation', undefined>, polStartDateSchema, polEndDateSchema) => {
  return yup.object().shape({
    dateIncident: yup
      .date()
      .min(polStartDateSchema, t('viriyah.validate-message.make-claim.protectionDay'))
      .max(dayjs().toDate(), t('viriyah.validate-message.make-claim.dateIncident'))
      // .max(polEndDateSchema, t('viriyah.validate-message.make-claim.protectionDay'))
      .typeError(t('viriyah.validate-message.make-claim.dateIncident'))
      .required(t('viriyah.validate-message.make-claim.dateIncident'))
      .test('pol_end_date', t('viriyah.validate-message.make-claim.protectionDay'), function (value) {
        const date = dayjs(value).toDate()
        if (date <= polEndDateSchema) return true
        return false
      }),
    incidentLocation: yup.string().required(t('viriyah.validate-message.make-claim.incidentLocation')),
    incidentLandmark: yup.string(),
    haveLitigant: yup.string().required(t('viriyah.validate-message.make-claim.haveLitigant')),
    errorMessage: yup.string(),
    incidentLocationLng: yup.string(),
    incidentLocationLat: yup.string()
  })
}

export default view(() => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const dataRadio: IValueString[] = [
    { value: 'Litigant', label: 'มีคู่กรณี' },
    { value: 'notLitigant', label: 'ไม่มีคู่กรณี' }
  ]
  // const polStartDateSchema = dayjs('18-03-2022 00:00:00', 'DD-MM-YYYY').toDate()
  // const polEndDateSchema = dayjs('18-09-2022 16:30:00', 'DD-MM-YYYY').toDate()
  const polStartDateSchema = dayjs(newNotifyStore.polStartDate, 'DD-MM-YYYY').toDate()
  const polEndDateSchema = dayjs(newNotifyStore.polEndDate, 'DD-MM-YYYY').toDate()
  const {
    control,
    register,
    handleSubmit,
    watch,
    setValue,
    getValues,
    formState: { errors }
  } = useForm<MakeClaimFormState>({
    defaultValues: {
      dateIncident: '',
      incidentLocation: '',
      incidentLandmark: '',
      haveLitigant: '',
      errorMessage: '',
      incidentLocationLng: '',
      incidentLocationLat: ''
    },
    resolver: yupResolver(validationSchema(t, polStartDateSchema, polEndDateSchema))
  })
  console.log('🚀 ~ file: MakeClaim.tsx ~ line 83 ~ view ~ watch', watch())

  const { isOpen, onOpen, onClose } = useDisclosure()

  const checkFormInput = (): boolean => {
    const { dateIncident, incidentLocation, haveLitigant, incidentLocationLng, incidentLocationLat } = watch()
    if (
      dateIncident !== '' &&
      dateIncident !== null &&
      incidentLocation !== '' &&
      haveLitigant !== '' &&
      incidentLocationLng !== '' &&
      incidentLocationLat !== ''
    ) {
      return false
    } else {
      return true
    }
  }

  const onSubmit: SubmitHandler<MakeClaimFormState> = () => {
    const { dateIncident, incidentLocationLat, incidentLocationLng, incidentLandmark, haveLitigant, incidentLocation } =
      watch()

    newNotifyStore.setMakeClaim(
      dateIncident,
      incidentLocation,
      incidentLocationLat.toString(),
      incidentLocationLng.toString(),
      incidentLandmark.length === 0 ? '-' : incidentLandmark,
      haveLitigant === 'Litigant' ? 'Y' : 'N'
    )
    navigate('/appointment-claim-information', { replace: true })
  }

  return (
    <section id="make-claim-form-page" className="pt-17">
      <div className="container">
        {getValues('errorMessage') !== '' && <AlertError message={getValues('errorMessage')} />}

        <Text fontSize="24px" fontWeight="bold" className="title-screen">
          {t('viriyah.make-claim-page.claim-information.title')}
        </Text>
        <Text fontSize="16px" color="#757575">
          {t('viriyah.make-claim-page.title-alert-off')}
        </Text>

        <form id="make-claim-form" className="form-group" onSubmit={handleSubmit(onSubmit)}>
          {/* ระบุวันที่และเวลาเกิดเหตุ */}
          <FormItem
            mt="5%"
            mb="5%"
            label={t('viriyah.make-claim-page.claim-information.label-date-incident')}
            select="dateTime"
            id="dateIncident"
            placeholder={t('viriyah.make-claim-page.claim-information.input-placeholder-date-incident')}
            isError={errors.dateIncident?.message}
            control={control}
            isRequired={true}
          />

          {/* ระบุตำแหน่งที่เกิดเหตุ */}
          <FormItem
            mb="5%"
            id="incidentLocation"
            label={t('viriyah.make-claim-page.claim-information.label-incident-location')}
            select="googleMap"
            register={register}
            isError={errors.incidentLocation?.message}
            placeholder={t('viriyah.make-claim-page.claim-information.input-placeholder-incident-location')}
            IconRight={<HiLocationMarker className="icon-input-right" />}
            onChange={onOpen}
            isRequired={true}
          />

          {/* ระบุจุดสังเกตของสถานที่ */}
          <FormItem
            mb="5%"
            id="incidentLandmark"
            label={t('viriyah.make-claim-page.claim-information.label-incident-landmark')}
            select="input"
            register={register}
            placeholder={t('viriyah.make-claim-page.claim-information.input-placeholder-incident-location')}
            isError={errors.incidentLandmark?.message}
          />

          {/* อุบัติเหตุนี้มีคู่กรณีหรือไม่ */}
          <FormItem
            mb="5%"
            id="haveLitigant"
            value={getValues('haveLitigant')}
            label={t('viriyah.make-claim-page.claim-information.label-have-litigant')}
            select="radio"
            onChange={e => setValue('haveLitigant', e)}
            options={dataRadio}
            register={register}
            isError={errors.haveLitigant?.message}
            isRequired={true}
          />
        </form>
        <ModalGoogleMap isOpen={isOpen} onClose={onClose} setValue={setValue} />
      </div>

      <div className="bottom-section">
        <ButtonChakra
          customBgColor="#0033A2"
          textColor="white"
          type="submit"
          isDisable={checkFormInput()}
          form="make-claim-form"
        >
          {t('viriyah.make-claim-page.button-next-submit')}
        </ButtonChakra>
      </div>
    </section>
  )
})
